var map = {
	"./aed.png": 331,
	"./aud.png": 332,
	"./bgn.png": 333,
	"./bhd.png": 334,
	"./cad.png": 335,
	"./chf.png": 336,
	"./cny.png": 337,
	"./czk.png": 338,
	"./dkk.png": 339,
	"./eur.png": 340,
	"./gbp.png": 341,
	"./hkd.png": 342,
	"./hrk.png": 343,
	"./huf.png": 344,
	"./idr.png": 345,
	"./ils.png": 346,
	"./inr.png": 347,
	"./jpy.png": 348,
	"./kes.png": 349,
	"./kwd.png": 350,
	"./mxn.png": 351,
	"./myr.png": 352,
	"./nok.png": 353,
	"./nzd.png": 354,
	"./omr.png": 355,
	"./php.png": 356,
	"./pln.png": 357,
	"./qar.png": 358,
	"./ron.png": 359,
	"./rub.png": 360,
	"./sar.png": 361,
	"./sek.png": 362,
	"./sgd.png": 363,
	"./thb.png": 364,
	"./try.png": 365,
	"./ugx.png": 366,
	"./usd.png": 367,
	"./zar.png": 368
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 330;